// SharedNodeModal.js
import React, { useState, useEffect } from "react";

const SharedNodeModal = ({ isOpen, onClose, dagNode, allDagNodes, diagramId, modalEditMode, partialUsers }) => {
  //TODO Add on close check on this variable
  const [scheduleTempValue, setScheduleTempValue] = useState(null);
  const [dagNodeData, setDagNodeData] = useState({
    name: "",
    description: "",
    duedate: "",
    completed_at: "",
    notes: "",
    optional: false,
    parentIds: [],
    scheduleValue: null,
    diagramId: diagramId,
    next_reset_at: "",
    last_reset_at: "",
  });

  const nameInUseMessage = "The name you entered for this node is already in use - the node has not been ";

  useEffect(() => {
    if (isOpen && allDagNodes?.length > 0) {
      setDagNodeData(allDagNodes[0]);
    }
  }, [isOpen]);

  useEffect(() => {
    if (dagNode !== null) {
      setDagNodeData(dagNode);
      setScheduleTempValue(dagNode.scheduleValue !== null ? dagNode.scheduleValue : null);
    } else {
      setDagNodeData({
        name: "",
        description: "",
        duedate: "",
        completed_at: "",
        notes: "",
        optional: false,
        parentIds: [],
        scheduleValue: null,
        diagramId: diagramId,
      });
    }
  }, [dagNode]);

  if (!isOpen) return null;

  const setScheduleModalInDagNode = (bool) => {
    dagNodeData["scheduleValue"] = bool ? scheduleTempValue : null;
  }

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setDagNodeData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSelectChange = (e) => {
    const selectedNodeName = e.target.value;
    const selectedNode = allDagNodes?.find(node => node.name === selectedNodeName);
    setDagNodeData(selectedNode);
  };

  function formatDateString(dateString) {
    var t = dateString.split(/[- :]/);
    // Apply each element to the Date function
    return t[0] + "-" + t[1] + "-" + t[2];
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    setScheduleModalInDagNode(true);
    
    // Opens a modal where you can select from a dropdown of all the nodes and also enter a pin value
    const pinValue = prompt("Enter a pin value for this user:");
    if (pinValue) {
      dagNodeData["pinValue"] = pinValue;
    } else {
      alert("Pin value is required to proceed.");
      // Cancel request and close prompt
      return;
    }
    // Update so that a popup shows for a user to input a value
    // Add this value to the bodyValue to be picked up by api
    // Add pinValue to the bodyValue
    dagNodeData["selectedUser"] = document.getElementById("selectedUser").value;

    const csrfToken = document.querySelector("[name=csrf-token]").content;

    if ((dagNode === null || modalEditMode)) {
        fetch("/dag_nodes/", {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify(dagNodeData),
        })
        .then((response) => {if (response.status === 409) {
          setScheduleModalInDagNode(false);
          alert(nameInUseMessage + "created");
        } else {
          window.location.reload();
        }})
        .catch((error) => {
            console.error("Error:", error);
        });
    } else {
        fetch("/dag_nodes", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify(dagNodeData),
        })
        .then((response) => {if (response.status === 409) {
          setScheduleModalInDagNode(false);
          alert(nameInUseMessage + "created");
        } else {
          window.location.reload();
        }})
        .catch((error) => {
            console.error("Error:", error);
        });
    }
  };

  function clearCompletedAtDatefield(elementName) {
    setDagNodeData({ ...dagNodeData, [elementName]: "" });
    document.getElementById(elementName).value = "";
    document.getElementById(elementName).setAttribute("value", "");
  }

  const scheduleTempValueAsString = () => {
    if (scheduleTempValue !== null && scheduleTempValue !== undefined && scheduleTempValue !== ""
        && scheduleTempValue["reset_schedule"] !== null && scheduleTempValue["reset_schedule"] !== undefined && scheduleTempValue["reset_schedule"] !== "") {
        return scheduleTempValue["reset_schedule"] + (scheduleTempValue["is_reoccurring"] ? " - Reoccurring" : " - One-off");
    }
    return "No Schedule Set";
  }

  return (
    <div className="overflow-y-auto flex h-screen flex-col flex-grow modal fixed inset-0 items-center justify-center z-50">
      <div style={{ backgroundColor: '#f1f0f5'}} className="modal-content flex flex-col h-screen overflow-hidden overflow-y-auto bg-white rounded-lg shadow-lg p-2">
        <header className="w-full text-center border-b border-grey p-4">
          <div className="flex justify-between items-center">
            <h1 className="modal-title text-2xl font-semibold text-gray-800">{(dagNode === null || modalEditMode) ? "Edit Node" : "Create Node"}</h1>
            <div>
                <i className="bi bi-x-lg cursor-pointer" onClick={onClose}></i>
            </div>
          </div>
        </header>
        <main className="flex-1 overflow-y-scroll p-2">
          { (dagNode === null || modalEditMode) && 
              <>
              <label htmlFor="dagNode" className="mb-2 font-semibold text-gray-700">Node: </label>
              <select id="dagNodeSelector" name="dagNode" onChange={handleSelectChange} className="max-w-full border border-gray-300 p-2 rounded">
                  {allDagNodes?.map((node, index) => (
                      <option key={index} value={node.name}>{node.name}</option>
                  ))}
              </select>
              </>
          }
          <form id="nodeModal" onSubmit={handleSubmit}>

          <div className="my-4 bg-gray-600 h-[1px]"></div>

          <label htmlFor="user" className="mb-2 font-semibold text-gray-700">User Updating: </label>
          <select
            id="selectedUser"
            name="selectedUser"
            className="max-w-full border border-gray-300 p-2 rounded"
          >
            {partialUsers?.map((user, index) => (
              <option key={index} value={user}>
                {user}
              </option>
            ))}
          </select>

          <div className="my-4 bg-gray-600 h-[1px]"></div>

            <div className="flex flex-col">
              <label htmlFor="name" className="mb-2 font-semibold text-gray-700">Name</label>
              <span
                className="mb-2"
                name="name"
              >{dagNodeData.name}</span>

              <div className="my-4 bg-gray-600 h-[1px]"></div>

              <label htmlFor="description" className="mb-2 font-semibold text-gray-700">Description</label>
              <span
                className="mb-2"
                name="description"
              >{dagNodeData.description}</span>

              <div className="my-4 bg-gray-600 h-[1px]"></div>

              <label htmlFor="duedate" className="mb-2 font-semibold text-gray-700">Due Date</label>
              <div className="flex justify-between">
                <span
                  id="duedate"
                  name="duedate"
                  className="mb-2" 
                >{dagNodeData.duedate ? formatDateString(dagNodeData.duedate) : "No Due Date"}</span>
              </div>

              <label htmlFor="completed_at">Completed Date</label>
              <div className="flex justify-between">
                <input
                  type="date"
                  id="completed_at"
                  name="completed_at"
                  value={dagNodeData.completed_at ? formatDateString(dagNodeData.completed_at) : ""}
                  onChange={handleChange}
                  className="flex-grow mr-1" 
                />
                <button type="button" 
                        onClick={() => clearCompletedAtDatefield("completed_at")} 
                        className="flex-shrink-0 ml-2 bg-zinc-500 hover:bg-zinc-700 text-white font-bold py-1 px-2 rounded object-right">
                          Clear
                </button>
              </div>
              <div className="my-4 bg-gray-600 h-[1px]"></div>

              <label htmlFor="notes" className="mb-2 font-semibold text-gray-700">Notes</label>
              <span
                className="mb-2" 
                name="notes"
              >{dagNodeData.notes}</span>

              <div className="my-4 bg-gray-600 h-[1px]"></div>

              <label htmlFor="notes" className="mb-2 font-semibold text-gray-700">Optional</label>
              <span
                className="mb-2" 
                name="optional"
              >{dagNodeData.optional ? "Yes" : "No"}</span>

              <div className="my-4 bg-gray-600 h-[1px]"></div>

              <label htmlFor="dagNodeParents" className="mb-2 font-semibold text-gray-700">Parent Links: </label>
              {dagNodeData.parentIds.map((id, index) => {
                const node = allDagNodes?.find(node => node.id === id);
                return (
                  <div key={index} className="flex items-center mb-2">
                    <span className="mr-2">{node.name}</span>
                  </div>
                );
              })}

              <div className="my-4 bg-gray-600 h-[1px]"></div>
                    
              <label htmlFor="scheduleModal" className="mb-2 font-semibold text-gray-700">Completed Date Reset Schedule: </label>
              <div className="flex justify-between">
                  <p name="scheduleValue" value={scheduleTempValue}>{scheduleTempValueAsString()}</p>
              </div>
              </div>
              { (dagNodeData["scheduleValue"] !== null && dagNodeData["scheduleValue"] !== undefined && dagNodeData["scheduleValue"]["next_reset_at"] !== "" && dagNodeData["scheduleValue"]["next_reset_at"] !== null) && (
              <> 
              <br></br>
              <p name="nextResetAt" value={dagNodeData["next_reset_at"]}>Next Reset at: {dagNodeData["next_reset_at"]}</p>
              </>)
              }
              { (dagNodeData["scheduleValue"] !== null && dagNodeData["scheduleValue"] !== undefined && dagNodeData["scheduleValue"]["last_reset_at"] !== "" && dagNodeData["scheduleValue"]["last_reset_at"] !== null) && (
              <> 
              <br></br>
              <p name="lastResetAt" value={dagNodeData["last_reset_at"]}>Last Reset at: {dagNodeData["last_reset_at"]}</p>
              </>)
              }
          </form>
        </main>
        <footer className="w-full text-center border-t border-grey p-2">
          <div className="flex justify-between">
            <button form="nodeModal" type="submit" className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded ml-auto">
                {(dagNode === null || modalEditMode) ? "Update" : "Create"}
            </button>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default SharedNodeModal;
